<template>
  <Modal name="BULK_RESCHEDULE_MODAL" width="380" :title="$t('appointment.confirmAppointment.rescheduleModal.title')" actions>
    <template v-slot:body>
      <div>
        <v-alert class="blue lighten-5">
          <p class="body-2 blue--text mb-2">
            {{ $t('appointment.confirmAppointment.rescheduleModal.rescheduleWarningMessage', { quantity: selectedAppointments.length }) }}
          </p>
          <v-chip v-for="(item, index) in selectedAppointments" :key="index" class="mr-1 mb-1 blue" x-small>
            <span class="white--text">
              {{ item.code }}
            </span>
          </v-chip>
        </v-alert>

        <p class="mb-2">
          {{ $t('appointment.confirmAppointment.rescheduleModal.rescheduleMessage') }}
        </p>

        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="6">
              <SelectDate v-model="date" :minDate="today" :rules="[required]" :label="$t('appointment.confirmAppointment.rescheduleModal.date')" />
            </v-col>
            <v-col>
              <SelectHourEmpty v-model="hour" :limitHours="true" :date="date" :rules="[required]"   />
            </v-col>
          </v-row>

          <HSlotSize v-show="country !== 'BR'" v-model="slot_size" :default-value="slot_size" class="mt-3" />
        </v-form>
      </div>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="loading"
        elevation="0"
        color="grey"
        text
      >
        {{ $t('appointment.confirmAppointment.rescheduleModal.cancel') }}
      </v-btn>
      <v-btn
        @click="updateAppointments"
        :loading="loading"
        color="primary"
        elevation="0"
        class="ml-5"
      >
        {{ $t('appointment.confirmAppointment.rescheduleModal.reschedule') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import moment from 'moment'
import { api } from '@/services'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { dateHourTimezone } from '@/util/catalog'
import { required } from '../../../util/errorHandling'

import Modal from '../../app/Modal'
import SelectDate from '../../date/SelectDate'
import SelectHourEmpty from '../../date/SelectHourEmpty'
import HSlotSize from '@/components/app/HSlotSize'

export default {
  name: 'ModalBulkReschedule',

  components: {
    Modal,
    SelectDate,
    SelectHourEmpty,
    HSlotSize,
  },

  props: {
    selectedAppointments: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['user']),

    country() {
      return this.user?.country ?? localStorage.getItem('user_country')
    },

    isAdminOrPartner() {
      const roles = localStorage.getItem('access_roles')
      const userRoles = roles?.split(',')
      return userRoles?.includes('ROLE_ADMIN') || userRoles?.includes('ROLE_PARTNER')
    },
  },

  methods: {
    ...mapActions(['bulkRescheduleAppointments', 'showSuccessMessage', 'showErrorMessage']),
    ...mapMutations(['closeAllModals']),

    createPayload() {
      const new_date = dateHourTimezone(this.date, this.hour)

      return {
        new_date,
        slot_size: this.slot_size,
        appointment_ids: this.selectedAppointments.map(appointment => appointment.id),
      }
    },

    async updateAppointments() {
      if (!this.$refs.form.validate()) return

      this.loading = true

      const userPath = this.isAdminOrPartner ? 'admin' : 'web'

      try {
        await api.post(`${userPath}/appointmentGroup/changeAppointmentsDate`, this.createPayload())
        this.showSuccessMessage('Appointments rescheduled with success')
        this.$emit('refreshMap')
        this.closeAllModals()
      } catch ({ data }) {
        this.showErrorMessage(data?.message || 'An error occurred while rescheduling appointments. Try again later.')
      } finally {
        this.loading = false
      }
    }
  },

  data() {
    return {
      date: null,
      hour: null,
      today: moment().format('YYYY-MM-DD'),
      slot_size: 0,
      loading: false,
      required,
    }
  }
}
</script>
